<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="dialog_visable"
			:formData="formData"
			ref="formData"
			dialogWidth="600px"
			@handleClose="close"
		>
			<dialogtitle
				slot="title"
				subtitle="您正在进行转移线索操作"
				title="线索转移"
				:subStyle="{ display: 'block', fontSize: '12px', marginLeft: 0 }"
			></dialogtitle>
			<dialogfooter
				slot="footer"
				:visible.sync="dialog_visable"
				@onclose="close"
				@confirm="submit"
			></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogtitle from '@/components/crm/crm-dialog-title.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import Name from '@/components/crm/crm-form-name.vue';
import clueSer from '@/client/services/clue/clueSer.js';
import { mapGetters, mapActions } from 'vuex';
import { validRequired } from '@/common/elementValid.js';
export default {
	props: {
		getDetailsData: {
			type: Object,
		},
		visible: {
			type: Boolean,
		},
	},
	data() {
		let that = this;
		return {
			formData: {
				salesleadsId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: '',
				},
				name: {
					label: '线索名称：',
					formType: Name,
					value: '',
				},
				move: {
					label: '转移至：',
					key: 'accountIds',
					value: '',
					multiple: false,
					options: that.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					placeholder: '请选择服务人员',
					rules: [validRequired('请选择服务人员', 'change')],
				},
			},
			dialog_visable: false,
			blongerIds: [],
			avatarUrl: '',
			employee: [],
		};
	},
	watch: {
		visible: {
			handler() {
				this.dialog_visable = this.visible;
				this.eventBus();
			},
		},
	},
	computed: {
		...mapGetters(['chatListData','allChatList']),
	},
	methods: {
		...mapActions(['getEmployeeList']),
		async getEmployee() {
			this.employee = await this.getEmployeeList();
			return this.employee;
		},
		async eventBus() {
			// 获取跟进人列表
			// eslint-disable-next-line no-unused-vars
			let res = await clueSer.followList({
				salesleadsId: this.getDetailsData.summaryId,
			});
			this.blongerIds = res && res.data.length ? res.data.map(item => item.accountId) : undefined;
			let value = '';
			if (this.blongerIds && this.blongerIds.length > 1) {
				value = this.blongerIds[0];
			} else {
				value = this.blongerIds ? this.blongerIds.toString() : '';
			}
			let that = this;
			this.formData = {
				salesleadsId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: this.getDetailsData.summaryId,
				},
				name: {
					label: '线索名称：',
					formType: Name,
					value: this.getDetailsData.userName,
				},
				move: {
					label: '转移至：',
					key: 'accountIds',
					value: value,
					multiple: false,
					options: this.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					placeholder: '请选择服务人员',
					rules: [validRequired('请选择服务人员', 'change')],
					change(val) {
						if (that.employee && that.employee.length > 0) {
							that.employee.forEach(e => {
								if (e.id == val) {
									that.avatarUrl = e.avatarUrl;
								}
							});
						}
					},
				},
			};
		},
		close() {
			this.dialog_visable = false;
			this.$emit('update:visible', false);
		},
		submit() {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					let params = {
						salesleadsId: this.getDetailsData.summaryId, //线索ID
						accountIds: [this.formData.move.value], //跟进人ID
						ids: this.blongerIds ? this.blongerIds : [], //之前跟进人ID
					};
					let res = await clueSer.transferClue(params);
					if (res) {
						this.dialog_visable = false;
						this.blongerIds = [];
						//对聊天列表数据进行处理，线索转移，跟进人字段更新，请求聊天记录接口，抽屉关闭
						let item;
					if (this.$route.name == 'allChat') {
						 item = this.allChatList.find(e => e.id == this.getDetailsData.summaryId);
						//列表跟进人头像数据替换，
						this.allChatList.forEach(e => {
							if (e.id == this.getDetailsData.summaryId) {
								e.followupName = this.formData.move.value;
								e.followupHeadPath = this.avatarUrl;
							}
						});
					}else{
						item = this.chatListData.find(e => e.id == this.getDetailsData.summaryId);
						//列表跟进人头像数据替换，
						this.chatListData.forEach(e => {
							if (e.id == this.getDetailsData.summaryId) {
								e.followupName = this.formData.move.value;
								e.followupHeadPath = this.avatarUrl;
							}
						});
					}
						this.$router.push({
							name: this.$route.name,
							query: {
								followupName: this.formData.move.value,
								type: item.type,
								id: item.id,
								tableId: item.tableId,
							},
						});
						this.$emit('changeName');
						this.$emit('update:visible', false);
						this.$message.success(`操作成功`);
					} else {
						this.$message.info(`操作失败`);
					}
				}
			});
		},
	},
	mounted() {
		this.getEmployee();
	},
	components: {
		formDialog,
		dialogtitle,
		dialogfooter,
		Name,
	},
};
</script>
<style lang="scss">
.el-popper {
	z-index: 10000 !important;
}
</style>
